import axios from 'axios';

export const AUTH_LOGOUT_EVENT = 'auth:logout';
export const AUTH_FORBIDDEN_EVENT = 'auth:forbidden';

const api = axios.create({
	baseURL: process.env.REACT_APP_API_URL
});

const AUTH_SKIP_401_PATHS = [
	'/api/auth/login',
	'/api/auth/register',
	'/api/auth/phone/request-otp',
	'/api/auth/phone/verify-otp',
];

api.interceptors.response.use(
	(response) => response,
	(error) => {
		const status = error?.response?.status;
		const currentPath = window.location.pathname + window.location.search;
		const requestUrl = String(error?.config?.url ?? '');
		const isAuthAttempt = AUTH_SKIP_401_PATHS.some((path) =>
			requestUrl.includes(path)
		);

		if (status === 401 && !isAuthAttempt) {
			window.dispatchEvent(new CustomEvent(AUTH_LOGOUT_EVENT));
		}

		if (status === 403) {
			window.dispatchEvent(
				new CustomEvent(AUTH_FORBIDDEN_EVENT, {
					detail: {
						message: error?.response?.data?.message || 'Acesso negado',
						path: currentPath,
					},
				})
			);
		}

		return Promise.reject(error);
	}
);

export default api;
